import { ContainerModule } from 'inversify';
import BannersRepository from '../features/banners/data/BannersRepository';
import { BannersServiceInterface } from '../features/banners/data/service/bannersService.types';
import { BannersRepositoryInterface } from '../features/banners/domain/BannersRepositoryInterface';
import BannersService from 'src/features/banners/data/service/bannersService';

export const bannersBindings = new ContainerModule((bind) => {
  bind<BannersServiceInterface>(BannersService).to(BannersService);
  bind<BannersRepositoryInterface>(BannersRepository).to(BannersRepository);
});
